import { MouseBlocker } from "@lib/titan2/dist/game/control/MouseBlocker";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { OrientationType } from "@lib/titan2/dist/game/renderer/constant/RendererConstants";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
import { ViewUtils } from "@lib/titan2/dist/util/view/ViewUtils";
import { Linear, gsap } from "gsap";
import { SlingoEvent } from "../../../controller/event/SlingoEvent";
import { TweenConstants } from "../constant/TweenConstants";
import { SlingoStyle } from "../style/SlingoStyle";
import { AbstractGameView } from "./AbstractGameView";
/**
 * BigWin.ts
 */
export class BigWin extends AbstractGameView {
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
        this.uiProperties = this.uiProperties;
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(SlingoEvent.BIG_WIN_ANIMATION_PHASE_TWO, this.handlePlayBigWin);
    }
    create() {
        super.create();
        this.createMouseBlocker();
        this.animation = TitanSpine.createSpine(this, this.landscapeProperties.animationProperties, this.portraitProperties?.animationProperties);
        this.counter = ViewUtils.createField(this.animation, this.landscapeProperties.counterProperties, this.portraitProperties?.counterProperties);
    }
    createMouseBlocker() {
        if (this.uiProperties.mouseBlockerProperties) {
            this.mouseBlocker = new MouseBlocker(this.landscapeProperties.mouseBlockerProperties, this.portraitProperties?.mouseBlockerProperties);
        }
    }
    showOverlay() {
        if (this.mouseBlocker) {
            this.mouseBlocker.alpha = 0;
            this.addChildAt(this.mouseBlocker, 0);
            gsap.to(this.mouseBlocker, { duration: TweenConstants.DEFAULT_OVERLAY_FADE_DURATION, alpha: 1 });
        }
    }
    hideOverlay() {
        this.mouseBlocker && gsap.to(this.mouseBlocker, {
            duration: TweenConstants.DEFAULT_OVERLAY_FADE_DURATION,
            alpha: 0,
            onComplete: () => {
                this.removeChild(this.mouseBlocker);
            }
        });
    }
    postCreate() {
        super.postCreate();
        this.reset();
        Logger.addObjectRef(this, "BigWin");
    }
    reset() {
        SpineUtil.reset(this.animation);
        this.counterValue = 0;
        this.counter.setText("");
    }
    handlePlayBigWin() {
        const landscape = this.renderer.getOrientation() === OrientationType.LANDSCAPE;
        this.dispatchGame(SlingoEvent.BIG_WIN_APPEAR);
        this.showOverlay();
        SpineUtil.play(this.animation, landscape ? SlingoStyle.BIG_WIN_IN_LANDSCAPE : SlingoStyle.BIG_WIN_IN_PORTRAIT, () => {
            this.animation.play(landscape ? SlingoStyle.BIG_WIN_LOOP_LANDSCAPE : SlingoStyle.BIG_WIN_LOOP_PORTRAIT, true);
            const totalWin = this.model.getTotalWin();
            this.counter.setText(this.formatCurrency(0));
            this.counter.visible = this.uiProperties.showCounter;
            this.dispatchGame(SlingoEvent.BIG_WIN_COUNT);
            gsap.to(this, {
                counterValue: totalWin,
                duration: this.uiProperties.counterDuration,
                ease: Linear.easeNone,
                onUpdate: () => {
                    this.counter.setText(this.formatCurrency(this.counterValue));
                },
                onComplete: () => {
                    this.dispatchGame(SlingoEvent.BIG_WIN_COUNT_END);
                    gsap.timeline()
                        .to(this.counter.scale, { x: 1.1, y: 1.1, duration: TweenConstants.YOYO_DURATION, yoyo: true, repeat: 1 })
                        .call(() => {
                        this.hideOverlay();
                        this.dispatchGame(SlingoEvent.BIG_WIN_DISAPPEAR);
                        SpineUtil.play(this.animation, landscape ? SlingoStyle.BIG_WIN_OUT_LANDSCAPE : SlingoStyle.BIG_WIN_OUT_PORTRAIT, this.handleAnimationComplete, this);
                    });
                }
            });
        });
    }
    handleAnimationComplete() {
        this.reset();
        this.dispatchGame(SlingoEvent.BIG_WIN_ANIMATION_COMPLETE);
    }
    isPlaying() {
        return this.animation.visible;
    }
}
//# sourceMappingURL=BigWin.js.map